import React from "react";

import { useDispatch } from "react-redux";

import { Button } from "@mui/material";

import AlertDialog from "./AlertDialog";
import { userSigupAction } from "../../redux/slices/user/userSignUpSlice";
import { TAILWIND_SUCCESS_BUTTON_RING_CLASS } from "../helpers/constants";

const OwnershipVerificationModal = ({
  isTailwindComponent = false,
  ownershipVerificationModal = false,
  goToNextStep = () => {},
  property_id = null,
  proeprty_data = {},
  OwnerName = null,
}) => {
  const dispatch = useDispatch();

  const setDefaultOwnerNameToProperty = () => {
    if (property_id) {
      dispatch(
        userSigupAction.setDefaultOwnerName({
          url: "property/update-owner-override-flag",
          data: { property_id, use_override_owner_name: true },
        }),
      );
    }
  };

  return (
    <>
      <AlertDialog
        isTailwindComponent={isTailwindComponent}
        type="Attention"
        width="sm"
        openPopup={ownershipVerificationModal}
        // onClose={true}
        // onCloseFun={() => setAddressPopup(false)}
        mesage={
          <>
            The property owner name retrieved from our database is{" "}
            <b>{proeprty_data?.owner}</b>.<br />
            Please specify whether to use this name or the one entered during
            account setup.
          </>
        }
        buttons={
          <>
            <Button
              className="popup_Btn other_popup_btn m-2"
              onClick={() => goToNextStep(false)}
            >
              Use {proeprty_data?.owner}
            </Button>
            <Button
              className={`m-2 ${
                isTailwindComponent
                  ? TAILWIND_SUCCESS_BUTTON_RING_CLASS
                  : "popup_Btn success_popup_btn"
              }`}
              onClick={() => setDefaultOwnerNameToProperty()}
            >
              Keep {OwnerName}
            </Button>
          </>
        }
      />
    </>
  );
};

export default OwnershipVerificationModal;
